<template>
    <div class="footer">
        <div class="footer-content">
            <div class="info-row">
                <span>地址：郑州市郑东新区CBD商务公园</span>
                <span>邮政编码：450000</span>
            </div>
            <div class="info-row">
                <span>浏览器支持：IE11以上浏览器</span>
                <span>服务热线：96288</span>
            </div>
            <div class="info-row">
                <span>豫ICP备2023405523号</span>
                <span>©2023河南农村商业银行</span>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Footer'
}
</script>

<style scoped>
.footer {
    background-color: #f5f5f5;
    padding: 20px 0;
    width: 100%;
}

.footer-content {
    width: 1200px;
    margin: 0 auto;
    text-align: center;
}

.info-row {
    margin: 8px 0;
    color: #666;
    font-size: 14px;
}

.info-row span {
    margin: 0 15px;
}

.cert-icons {
    margin-top: 15px;
    display: flex;
    justify-content: center;
    gap: 20px;
}

.cert-icon {
    width: 40px;
    height: 40px;
}
</style>